import React from 'react';
import { useSelector } from 'react-redux';

import type { RootState } from '../../../store/store';
import { ROUTES } from '../../../utils/routes';
import { hasModuleAccess } from '../../../utils/subscriptions';
import Step from './components/ProgressBarStep';

const steps = [
  { title: 'Validation des copropriétés', href: ROUTES.ANALYZING_VERIFY_COPROPRIETES, freemium: true },
  { title: 'Ajout des copropriétés', href: ROUTES.ANALYZING_ADD_COPROPRIETES, freemium: true },
  { title: 'Vérification des adresses', href: ROUTES.ANALYZING_ADD_ADDRESSES, freemium: true },
  { title: 'Qualification de l\'activité', href: ROUTES.SETUP_TRANSACTION_QUALIFICATION, freemium: false },
  { title: 'Paramétrage de l\'image de marque', href: ROUTES.SETUP_BRANDING, freemium: false },
  { title: 'Attribution des collaborateurs', href: ROUTES.SETUP_ADD_COLLABORATORS, freemium: false },
  { title: 'Configuration des alertes', href: ROUTES.SETUP_CONFIGURE_NOTIFICATIONS, freemium: false },
];

const ProgressBar = ({ currentStep }) => {
  const company = useSelector((state: RootState) => state.auth.company);
  const hasModuleAccessGranted = hasModuleAccess(company, 'monitoring');

  return (
    <div className="2xl:border-y 2xl:border-gray-200">
      <nav className="mx-auto max-w-7xl" aria-label="Progress">
        <ol
          role="list"
          className="overflow-hidden rounded-xl 2xl:flex 2xl:rounded-none"
        >
          {steps.map((step, stepIdx) => {
            const isClickable = hasModuleAccessGranted || step.freemium;
            const stepClass = isClickable
              ? 'clickable cursor-pointer'
              : 'unclickable bg-gray-200 bg-stripes-gray cursor-not-allowed'; // Add your zebra pattern class here and cursor style

            return (
              <li key={stepIdx} className={`relative overflow-hidden lg:flex-1 ${stepClass}`}>
                <Step
                  currentStep={currentStep}
                  step={stepIdx}
                  title={step.title}
                  href={isClickable ? step.href : '#'}
                  totalStep={steps.length}
                />
              </li>
            );
          })}
        </ol>
      </nav>
    </div>
  );
};

export default ProgressBar;
